import { tv } from 'tailwind-variants';

const PaperContainer = tv({
  base: 'p-4 rounded-4',
  variants: {
    cols: {
      single: 'columns-1',
      split: 'columns-2',
      three: 'columns-3',
    },
  },
});

const ExerciseText = tv({
  base: 'text-[#000] [&>p__img]:mx-auto [&>p__img]:my-2',
  variants: {
    size: {
      default: 'text-sm',
      small: 'text-xs',
    },
  },
});

const AnswerOpts = tv({
  base: 'block relative float-none text-[#000] [&>p]:flex [&>p]:flex-row [&>p]:items-center',
  variants: {
    size: {
      default: 'text-sm',
      small: 'text-xs',
    },
  },
});

const IconContainer = tv({
  base: 'w-fit px-2 py-1 rounded-t-md',
  variants: {
    color: {
      interdisciplinar: 'bg-[#00c4e6]',
      redacao: 'bg-[#4594c2]',
      literatura: 'bg-[#f78099]',
      espanhol: 'bg-[#bfab2e]',
      ingles: 'bg-[#6e8ff2]',
      portugues: 'bg-[#ff6b40]',
      gramatica: 'bg-[#f78099]',
      sociologia: 'bg-[#c9171a]',
      filosofia: 'bg-[#d3aa0e]',
      geografia: 'bg-[#05cc70]',
      historia: 'bg-[#ab664f]',
      matematica: 'bg-[#6b59a6]',
      fisica: 'bg-[#00b8ab]',
      quimica: 'bg-[#c41c6e]',
      biologia: 'bg-[#1a3ba6]',
      atualidades: 'bg-[#69BFA0]',
      'bioquimica-superior': 'bg-[#FF5900]',
      'anatomia-superior': 'bg-[#8B0000]',
      'histologia-humana-superior': 'bg-[#607D8B]',
      'fisiologia-superior': 'bg-[#2196F3]',
      'genetica-superior': 'bg-[#00BCD4]',
      'embriologia-superior': 'bg-[#4CAF50]',
      'imunologia-superior': 'bg-[#FFD700]',
      'microbiologia-superior': 'bg-[#9CCC65]',
      'parasitologia-superior': 'bg-[#795548]',
      'patologia-superior': 'bg-[#B71C1C]',
      'farmacologia-superior': 'bg-[#6A1B9A]',
    },
  },
});

const InfoLine = tv({
  base: 'w-full py-3 px-5 flex flex-row items-center justify-between',
  variants: {
    color: {
      interdisciplinar: 'bg-[#00c4e6]',
      redacao: 'bg-[#4594c2]',
      literatura: 'bg-[#f78099]',
      espanhol: 'bg-[#bfab2e]',
      ingles: 'bg-[#6e8ff2]',
      portugues: 'bg-[#ff6b40]',
      gramatica: 'bg-[#f78099]',
      sociologia: 'bg-[#c9171a]',
      filosofia: 'bg-[#d3aa0e]',
      geografia: 'bg-[#05cc70]',
      historia: 'bg-[#ab664f]',
      matematica: 'bg-[#6b59a6]',
      fisica: 'bg-[#00b8ab]',
      quimica: 'bg-[#c41c6e]',
      biologia: 'bg-[#1a3ba6]',
      atualidades: 'bg-[#69BFA0]',
      'bioquimica-superior': 'bg-[#FF5900]',
      'anatomia-superior': 'bg-[#8B0000]',
      'histologia-humana-superior': 'bg-[#607D8B]',
      'fisiologia-superior': 'bg-[#2196F3]',
      'genetica-superior': 'bg-[#00BCD4]',
      'embriologia-superior': 'bg-[#4CAF50]',
      'imunologia-superior': 'bg-[#FFD700]',
      'microbiologia-superior': 'bg-[#9CCC65]',
      'parasitologia-superior': 'bg-[#795548]',
      'patologia-superior': 'bg-[#B71C1C]',
      'farmacologia-superior': 'bg-[#6A1B9A]',
    },
  },
});

export { AnswerOpts, ExerciseText, IconContainer, InfoLine, PaperContainer };
